import React, { Fragment, useState } from 'react';
import { v4 as uuid } from 'uuid';
import PropTypes from 'prop-types';

const Form = ({ createDate }) => {
    const [dating, setDate] = useState({
        pet: '',
        owner: '',
        date: '',
        time: '',
        symptoms: ''
    });

    const [error, updateError] = useState(false);

    const handleChange = (e) => {
        setDate({
            // toma una copia del state date
            //spread operator or rest operator
            ...dating,
            //array destructuring
            [e.target.name]: e.target.value
        });
        // console.log(e.target.value);
        // console.log(e.target.name);
        // console.log("ecribiendo...");
    };

    //extraer valores
    const { pet, owner, date, time, symptoms } = dating;

    // cuando el usuario presiona agendar cita
    const submitDating = (e) => {
        e.preventDefault(); //si no se usa envia todos los datos por el metodo get
        // alert("Enviando");

        // validar
        if (pet.trim() === ''
            || owner.trim() === ''
            || date.trim() === ''
            || time.trim() === ''
            || symptoms.trim() === '') {
            // console.log("hay un error");
            updateError(true);
            return;
        }
        // Eliminar mensaje previo 
        updateError(false);
        // console.log("agregando...");
        // asignar id
        dating.id = uuid();
        // crear la cita 
        createDate(dating);
        // reiniciar el form
        setDate({
            pet: '',
            owner: '',
            date: '',
            time: '',
            symptoms: ''
        })

        // console.log(dating);
    }

    return (
        <Fragment>
            <h2>Crear cita</h2>

            {error ? <p className="alerta-error"> Todos los campos son obligatorios</p> : null}

            <form
                onSubmit={submitDating}
            >
                <label>Nombre mascota</label>
                <input
                    type="text"
                    name="pet"
                    className="u-full-width"
                    placeholder="Nombre mascota"
                    onChange={handleChange}
                    value={pet}
                />
                <label>Nombre dueño</label>
                <input
                    type="text"
                    name="owner"
                    className="u-full-width"
                    placeholder="Nombre dueño de la mascota"
                    onChange={handleChange}
                    value={owner}
                />
                <label>Fecha</label>
                <input
                    type="date"
                    name="date"
                    className="u-full-width"
                    onChange={handleChange}
                    value={date}
                />
                <label>Hora</label>
                <input
                    type="time"
                    name="time"
                    className="u-full-width"
                    onChange={handleChange}
                    value={time}
                />
                <label>Síntomas</label>
                <textarea
                    name="symptoms"
                    className="u-full-width"
                    onChange={handleChange}
                    value={symptoms}
                >
                </textarea>
                <button
                    type="submit"
                    className="u-full-width button-primary"
                >
                    Agregar cita
            </button>
            </form>
        </Fragment>
    );
}

// forma de documentar los componentes 
// para definir los type check 

Form.propTypes = {
    createDate : PropTypes.func.isRequired
}

export default Form;